export const API_URL = process.env.REACT_APP_API_URL;
// export const CRSM_URL = process.env.REACT_APP_CRSM_URL;
export const CRSM_URL = 'https://ws-ad-politie.politie.local'
